export enum ButtonSizeTypes {
    SMALL = "sm",
    LARGE = "lg"
}